import React, { useState } from 'react';
import Button from 'components/Button';
import { AuthModalStateProps } from '../../AuthModal.types';
import forgetPassword from '../../api/forgetPassword';
import styles from './RemindPassword.module.css';

const RemindPassword = ({ setModalState, onClose }: AuthModalStateProps) => {
  const [emailValue, setEmailValue] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [successResponse, setSuccessResponse] = useState(false);

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmailValue(e.target.value);
  };

  const isValidEmail = (email: string) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleEmailSubmit = async () => {
    if (emailValue.length === 0) {
      setError('Пожалуйста, заполните поле.');
      return;
    }
    if (!isValidEmail(emailValue)) {
      setError('Пожалуйста, введите корректный e-mail.');
      return;
    } else {
      setError(null);
    }

    const response = await forgetPassword(emailValue);

    if (!response) return setError('Произошла ошибка, попробуй позже');

    if (response?.message) return setSuccessResponse(true);

    if (response?.error) return setError(response.error);
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.gray_logo} />
        <span className={styles.icon_close} onClick={onClose} />
      </div>
      {!successResponse ? (
        <>
          <div className={styles.back} onClick={() => setModalState('entry')}>
            {'Назад'}
          </div>

          <div className={styles.content_container}>
            <h2 className={styles.title}>Восстановить пароль</h2>
            <p className={styles.subtitle}>
              Электронная почта, на&nbsp;которую зарегистрирован твой аккаунт
            </p>
            <form className={styles.form}>
              <input
                type="text"
                id="remind_pwd"
                className={`${styles.input} ${error ? styles.input_error : ''}`}
                value={emailValue}
                onChange={handleEmailChange}
                placeholder={'E-mail'}
              />
              {error && (
                <label htmlFor="remind_pwd" className={styles.label_error}>
                  {error}
                </label>
              )}
              <div className={styles.buttons}>
                <Button
                  text={'Восстановить'}
                  onClick={() => handleEmailSubmit()}
                  addStyles={{ padding: '15px 25px 16px', fontSize: 15 }}
                />
              </div>
            </form>
          </div>
        </>
      ) : (
        <div className={styles.success_container}>
          <h2 className={styles.title}>Восстановить пароль</h2>
          <p className={styles.subtitle}>
            Мы&nbsp;отправили письмо со&nbsp;ссылкой на&nbsp;смену пароля на&nbsp;
            {emailValue}
          </p>
          <span className={styles.info}>Если письма нет, проверь папку «Спам».</span>
          <div className={styles.buttons}>
            <Button
              text={'Войти'}
              onClick={() => setModalState('entry')}
              addStyles={{ padding: '15px 25px 16px', fontSize: 15 }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default RemindPassword;
